import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'az',
    fullName: 'Azerbaijani',
    nativeName: 'Azərbaycan',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Heyrətamiz bir şey gəlir",
    landing_subtitle: "ArgVoid proqram və oyun inkişaf etdirmə studiyasıdır. İzləmədə qalın, tezliklə yeni şeylər gələcək!",
    select_language: "Dil seçin",
    search_placeholder: "Dilləri axtarın...",
    terms_title: "Xidmət Şərtləri",
    policy_title: "Məxfilik Siyasəti",
    cookies_title: "Kuki Siyasəti",
    terms_content: `
        <strong>1. Şərtlərin qəbulu</strong><br>
        ArgVoid-ə daxil olmaqla, bu Xidmət Şərtləri qəbul edilir. Bu şərtlərlə razılaşdırılmadıqda, xidmətdən istifadə edilməməlidir.<br><br>

        <strong>2. Platformanın istifadəsi</strong><br>
        ArgVoid və onun tətbiqləri məlumat və yaradıcı məqsədlər üçün "olduğu kimi" təqdim olunur. Xidmət yalnız qanuni məqsədlər üçün istifadə edilməlidir.<br><br>

        <strong>3. Qadağan Edilən Davranış</strong><br>
        Saytın zəifliklərindən istifadə etmək, spam göndərmək və ya infrastruktura icazəsiz giriş cəhdi qəti qadağandır.<br><br>

        <strong>4. İmtina </strong><br>
        Platforma və xidmətlər istənilən vaxt xəbərdarlıq edilmədən dəyişdirilə bilər. Xidmətin işləmə müddəti və ya mövcudluğu ilə bağlı heç bir zəmanət verilmir.
    `,
    policy_content: `
        <strong>1. Məlumat toplusu</strong><br>
        Platforma hazırda istifadəçinin autentifikasiyası və ya hesab yaradılması tələb etmir. Ziyarətçilərdən heç bir şəxsi identifikasiya edən məlumat (adlar və ya e-poçt ünvanları kimi) aktiv şəkildə toplanmır.<br><br>

        <strong>2. İstifadə Data</strong><br>
        Sayt trafikini başa düşmək və tətbiqləri təkmilləşdirmək üçün əsas, anonim analitika toplana bilər. Bu məlumat fərdi istifadəçi identifikasiyası ilə əlaqələndirilmir.<br><br>

        <strong>3. Üçüncü Tərəf Xidmətləri</strong><br>
        Üçüncü tərəf provayderləri hostinq və analitik xidmətlər üçün istifadə edilə bilər. Bu müvafiq provayderlərin məxfilik təcrübələri onların infrastrukturunda işlənmiş anonim məlumatları idarə edir.<br><br>

        <strong>4. Məlumat Təhlükəsizliyi</strong><br>
        Platformanı qorumaq üçün ağlabatan təhlükəsizlik tədbirləri həyata keçirilir. Bununla belə, İnternet üzərindən heç bir ötürmə üsulu tamamilə təhlükəsiz deyil.<br><br>
    `,
    cookies_content: `
        <strong>1. Kukilər və Yerli Yaddaş nədir? </strong><br>
        Kukilər və brauzerin yerli yaddaşı ziyarətlər zamanı konfiqurasiya seçimlərini yadda saxlamaq üçün cihazda saxlanılan kiçik data fayllarıdır.<br><br>

        <strong>2. İstifadə Məqsədi</strong><br>
        Brauzer LocalStorage konfiqurasiya parametrlərini saxlamaq üçün ciddi şəkildə istifadə olunur, məsələn: <br>
        - Dil üstünlükləri<br>
        - İstifadəçi interfeysi konfiqurasiyası (məsələn, tərtibat və ya mövzu parametrləri) <br>
        - Müvəqqəti proqram cache<br><br>

        <strong>3. İzləmə yoxdur</strong><br>
        Kukilər və yerli yaddaş reklam və ya üçüncü tərəf izləmə məqsədləri üçün istifadə edilmir. Bütün saxlanılan məlumatlar ciddi şəkildə platformanın əsas funksionallığı üçündür.<br><br>

        <strong>4. Control</strong><br>
        Brauzer məlumatları istənilən vaxt brauzer parametrləri vasitəsilə silinə bilər ki, bu da istənilən yerli konfiqurasiyaları sıfırlayacaq.
    `,
    cookie_consent_text: "Biz veb-saytın düzgün işləməsini təmin etmək üçün əsas kukilərdən istifadə edirik, məsələn, sessiyanızı aktiv saxlamaq, dil seçiminizi saxlamaq və digər fərdi konfiqurasiyalar.",
    read_policy: "Kuki Siyasətini oxuyun",
    support_title: "Dəstək ilə əlaqə saxlayın",
    support_subject_label: "Mövzu",
    support_message_label: "Mesaj",
    support_submit_button: "Mesaj Göndər",
    support_hint: "Qeyd: Bu, mesajı göndərmək üçün standart e-poçt proqramınızı açacaq.",
    support_success_msg: "E-poçt tətbiqiniz açılır...",
    support_error_msg: "Mesaj göndərmək alınmadı. Daha sonra yenidən cəhd edin.",
    explorer_title: "Explorer",
    history_title: "Tarix",
    animation_title: "Animasiya",
    config_title: "Konfiqurasiya",
    tool_mouse: "Seçin (Ctrl+M)",
    tool_brush: "Fırça (Ctrl+B)",
    tool_brush_mode: "Dəyişdirmə Rejimi (Bərk/Təmiz)",
    tool_eraser: "Silgi (Ctrl+E)",
    tool_brush_size: "Fırça ölçüsünü tənzimləyin",
    tool_bucket: "Doldur (Ctrl+F)",
    tool_eyedropper: "Damcılıq",
    tool_grid: "Şəbəkə (Ctrl+Shift+B)",
    tool_rotate: "Döndür (Ctrl+Shift+R)",
    tool_flip_h: "H çevirin (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpoze (Ctrl+Shift+T)",
    label_width: "Genişlik",
    label_height: "Hündürlük",
    label_frames: "Çərçivələrin sayı",
    label_animation: "Animasiya üslubu",
    label_background_color: "Fon Rəngi",
    label_interval: "Interval",
    tool_anim_config: "Animasiya Konfiqurasiyası",
    label_new_width: "Yeni Eni",
    label_new_height: "Yeni Hündürlük",
    label_apply: "Müraciət edin",
    label_colors: "Rənglər",
    label_size: "Ölçü",
    label_tolerance: "Tolerantlıq",
    val_horizontal: "Üfüqi",
    val_vertical: "Şaquli",
    val_sequence: "Ardıcıllıq",
    val_bounce: "Sıçrayış",
    val_random: "Təsadüfi",
    val_solid: "Möhkəm",
    val_clear: "Təmiz",
    action_add_sheet: "Yeni Vərəq",
    action_import: "İdxal",
    action_export: "İxrac",
    action_sort_projects: "Sırala",
    sort_date_old: "Ən köhnə Birinci",
    sort_date_new: "Ən Yeni İlk",
    sort_name_az: "Ad (A-Z)",
    sort_name_za: "Ad (Z-A)",
    action_new_sprite: "Yeni Sprite",
    action_new_project: "Yeni Layihə",
    modal_save_all_title: "Bütün Dəyişiklikləri Saxla",
    modal_save_all_desc: "Saxlamaq üçün aktivləri seçin:",
    modal_save_selected: "Seçilmişi Saxla",
    action_saved: "Saxlandı",
    modal_create_sprite_title: "Yeni Sprite yaradın",
    modal_create_project_title: "Yeni Layihə Yaradın",
    modal_add_sheet_title: "Yeni vərəq əlavə edin",
    modal_rename_sheet_title: "Vərəqin adını dəyişdirin",
    modal_rename_sprite_title: "Sprite adını dəyişin",
    modal_delete_sprite_title: "Sprite-ı silin",
    modal_delete_project_title: "Layihəni silin",
    modal_delete_sheet_title: "Vərəqi silin",
    placeholder_sprite_name: "ad",
    placeholder_project_name: "ad",
    placeholder_sheet_name: "ad",
    placeholder_new_name: "Yeni Ad",
    action_create: "Yaradın",
    action_add: "əlavə et",
    action_rename: "Adını dəyişdirin",
    action_duplicate: "Dublikat",
    action_delete: "Sil",
    action_cancel: "Ləğv et",
    confirm_delete_sprite: "Bu spriti silmək istədiyinizə əminsiniz?",
    confirm_delete_project: "Bu layihəni silmək istədiyinizə əminsiniz? Bütün spritlər silinəcək.",
    confirm_delete_sheet: "Bu cədvəli silmək istədiyinizə əminsiniz?",
    err_select_sprite: "Lütfən, əvvəlcə sprit seçin.",
    err_select_project: "Əvvəlcə layihə seçin.",
    err_name_empty: "Ad boş ola bilməz.",
    err_sprite_exists: "Bu ada malik sprayt artıq mövcuddur.",
    err_project_exists: "Bu adda layihə artıq mövcuddur.",
    err_no_content: "Yadda saxlamaq üçün məzmun yoxdur.",
    err_no_changes: "Yadda saxlamaq üçün dəyişiklik yoxdur.",
    err_delete_last_sheet: "Son vərəqi silmək mümkün deyil.",
    err_extract_frames: "Heç bir çərçivə çıxarmaq mümkün olmadı.",
    err_indexeddb: "Lokal olaraq yadda saxlamaq alınmadı. Brauzeriniz IndexedDB-ni dəstəkləməyə bilər.",
    msg_upload_success: "Yükləmə Uğurlu: {0}",
    msg_upload_failed: "Yükləmə uğursuz oldu: {0}",
    msg_save_success: "Uğurlu yadda saxla.",
    msg_saving: "Yadda saxlanılır...",
    msg_multi_save_result: "Saxlanılan {0} aktiv. {1} uğursuzluq.",
    menu_title: "Menyu",
    menu_save: "Saxla",
    menu_save_all: "Hamısını Saxla",
    menu_support: "Dəstək ilə əlaqə saxlayın",
    label_local_storage: "Yerli Yaddaş",
    label_sign_in: "Daxil ol",
    modal_export_title: "Sprite ixrac edin",
    label_filename: "Fayl adı",
    label_format: "Format",
    action_export_confirm: "İxrac",
};

export default translations;
